!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : e["browser-data-cortex"] = n();
}(this, function () {
  "use strict";

  var e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      n = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      t = 10,
      r = 10,
      o = 2e3,
      i = ["kingdom", "phylum", "class", "order", "family", "genus", "species", "spend_currency", "spend_type", "network", "channel"],
      a = ["group_tag", "from_tag"],
      s = ["float1", "float2", "float3", "float4", "spend_amount"],
      d = W(i, a, s, ["type", "event_index", "event_datetime", "to_list"]),
      c = "https://api.data-cortex.com",
      u = c,
      f = !1,
      l = !1,
      p = !1,
      g = !1,
      v = !1,
      _ = "0",
      m = !1,
      w = [],
      y = !1,
      h = 0,
      x = !1,
      b = !1,
      O = 0,
      S = 0,
      k = {},
      E = [];

  function A() {
    for (var e, n = arguments.length, t = Array(n), r = 0; r < n; r++) {
      t[r] = arguments[r];
    }

    (e = console).error.apply(e, ["Data Cortex Error:"].concat(t));
  }

  function j(e) {
    e && B("Javascript Error: message:", e.message, "error:", e.error);
  }

  function P(e, n) {
    var t = void 0;

    if (e in window.localStorage) {
      var r = window.localStorage[e];

      try {
        t = JSON.parse(r);
      } catch (e) {}
    }

    return void 0 === t && (t = "function" == typeof n ? n() : n), t;
  }

  function F(e, n) {
    var t = JSON.stringify(n);
    window.localStorage[e] = t;
  }

  function C() {
    var e = "",
        n = window.crypto || window.msCrypto;

    if (n && n.getRandomValues) {
      var t = new Uint32Array(8);
      n.getRandomValues(t);

      for (var r = 0; r < t.length; r++) {
        e += t[r].toString(36);
      }
    } else for (; e.length < 32;) {
      e += Math.random().toString(36).slice(2);
    }

    return e = e.slice(0, 32);
  }

  function I() {
    Date.now() - h > 864e5 && (M({
      type: "dau"
    }), F("dc.last_dau_time", h = Date.now()));
  }

  function M(e) {
    e.event_index = O++, e.event_datetime || (e.event_datetime = new Date().toISOString()), x && (e.group_tag = x), i.forEach(function (n) {
      if (n in e) {
        var t = e[n],
            r = t && String(t);
        r ? e[n] = r.slice(0, 32) : delete e[n];
      }
    }), a.forEach(function (n) {
      if (n in e) {
        var t = e[n],
            r = t && String(t);
        r ? e[n] = r.slice(0, 64) : delete e[n];
      }
    }), s.forEach(function (n) {
      if (n in e) {
        var t = e[n];
        "number" != typeof t && (t = parseFloat(t)), isFinite(t) ? e[n] = t : delete e[n];
      }
    });
    var n = K(e, d);
    return w.push(n), F("dc.event_list", w), T(), n;
  }

  function T(e) {
    p || !f || l || (p = window.setTimeout(function () {
      p = !1, function () {
        if (f && !l && w.length > 0) {
          l = !0;
          var e = n({}, k, {
            api_key: g,
            app_ver: _,
            device_tag: b
          });
          m && (e.user_tag = m), e.events = [];
          var r = !1;
          w.some(function (n) {
            return r ? r.session_key === n.session_key && e.events.push(n) : (r = n, e.events.push(n)), e.events.length < t;
          });
          var i = encodeURIComponent(new Date().toISOString()),
              a = u + "/" + v + "/1/track?current_time=" + i,
              s = {
            url: a,
            method: "POST",
            body: e
          };
          q(s, function (n, t, r) {
            var i,
                a = !0;
            "status" === n ? 400 === t ? A("Bad request, please check parameters, error:", r) : 403 === t ? (A("Bad API Key, error:", r), f = !1) : 409 === t || (a = !1, S++) : n ? (a = !1, S++) : S = 0, a && (i = e.events, F("dc.event_list", w = w.filter(function (e) {
              return !i.some(function (n) {
                return e.event_index === n.event_index;
              });
            })), F("dc.next_index", O)), l = !1, w.length > 0 && T(S * o);
          });
        }
      }();
    }, e || 0));
  }

  function q(e, t) {
    var r = !1;

    function o() {
      r || (r = !0, t.apply(void 0, arguments));
    }

    var i = e.method,
        a = {
      Accept: "application/json"
    },
        s = null;
    e.body instanceof FormData ? s = e.body : e.body && (s = JSON.stringify(e.body), a["Content-Type"] = "text/plain");
    var d = n({}, a, e.headers),
        c = e.url,
        u = new XMLHttpRequest();
    e.timeout && (u.timeout = e.timeout), u.onload = function () {
      var e,
          n = 1223 == u.status ? 204 : u.status,
          t = null;
      e = u.response || u.responseText, n < 200 || n > 599 ? t = "wierd_status" : n >= 300 && (t = "status"), o(t, n, e);
    }, u.onerror = function () {
      o("xhr_error");
    }, u.ontimeout = function () {
      o("timeout");
    }, u.open(i, c, !0), L(d, function (e, n) {
      Array.isArray(e) ? e.forEach(function (e) {
        u.setRequestHeader(n, e);
      }) : u.setRequestHeader(n, e);
    }), u.send(s);
  }

  function B() {
    if (!arguments || 0 === arguments.length) throw new Error("log must have arguments");

    for (var n, t = "", r = 0; r < arguments.length; r++) {
      var o = arguments[r];
      if (r > 0 && (t += " "), (n = o) && n.stack && n.message && "string" == typeof n.stack && "string" == typeof n.message) t += o.stack;else if ("object" === (void 0 === o ? "undefined" : e(o))) try {
        t += JSON.stringify(o);
      } catch (n) {
        t += o;
      } else t += o;
    }

    V({
      log_line: t
    });
  }

  var D = ["repsonse_bytes", "response_ms"],
      R = {
    hostname: 64,
    filename: 256,
    log_level: 64,
    device_tag: 62,
    user_tag: 62,
    remote_address: 64,
    log_line: 65535
  },
      N = W(D, Object.keys(R), ["event_datetime"]);

  function V(n) {
    if (!n || "object" !== (void 0 === n ? "undefined" : e(n))) throw new Error("props must be an object.");
    n.event_datetime || (n.event_datetime = new Date().toISOString()), L(R, function (e, t) {
      if (t in n) {
        var r = n[t],
            o = r && r.toString();
        o ? n[t] = o.slice(0, e) : delete n[t];
      }
    }), D.forEach(function (e) {
      if (e in n) {
        var t = n[e];
        "number" != typeof t && (t = parseFloat(t)), isFinite(t) ? n[e] = t : delete n[e];
      }
    });
    var t = K(n, N);
    return E.push(t), F("dc.log_list", E), H(), t;
  }

  var J = !1,
      U = !1,
      X = 0;

  function H() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
    J || !f || U || (J = window.setTimeout(function () {
      J = !1, function () {
        if (f && !U && E.length > 0) {
          U = !0;
          var e = n({}, k, {
            api_key: g,
            app_ver: _,
            device_tag: b
          });
          m && (e.user_tag = m), e.events = E.slice(0, r);
          var t = u + "/" + v + "/1/app_log",
              i = {
            url: t,
            method: "POST",
            body: e
          };
          q(i, function (n, t, r) {
            var i,
                a = !0;
            "status" === n ? 400 === t ? A("Bad request, please check parameters, error:", r) : 403 === t ? A("Bad API Key, error:", r) : 409 === t || (a = !1, X++) : n ? (a = !1, X++) : X = 0, a && (i = e.events, E.splice(0, i.length), F("dc.log_list", E)), U = !1, E.length > 0 && H(X * o);
          });
        }
      }();
    }, e));
  }

  function L(e, n) {
    Object.keys(e).forEach(function (t) {
      var r = e[t];
      n(r, t, e);
    });
  }

  function K(e, n) {
    var t = {};
    return n.forEach(function (n) {
      n in e && (t[n] = e[n]);
    }), t;
  }

  function W() {
    for (var e = [], n = 0; n < arguments.length; n++) {
      var t = arguments[n];
      Array.prototype.push.apply(e, t);
    }

    return e;
  }

  var G = {
    init: function init(e, n) {
      u = e.base_url || P("dc.base_url", !1) || c, g = e.api_key, v = e.org_name, _ = e.app_ver || "0", m = P("dc.user_tag", !1), w = P("dc.event_list", []), O = P("dc.next_index", 0), w.forEach(function (e) {
        e.event_index >= O && (O = e.event_index + 1);
      }), E = P("dc.log_list", []), h = P("dc.last_dau_time", 0), y = P("dc.has_sent_install", 0) || Boolean(h), e.device_tag ? (b = e.device_tag, F("dc.device_tag", e.device_tag)) : (t = P("dc.device_tag", !1), t || F("dc.device_tag", t = C()), b = t), x || (x = C()), y || (y = !0, F("dc.has_sent_install", !0), M({
        type: "install",
        kingdom: "organic",
        phylum: "organic",
        class: "organic",
        order: "organic",
        family: "organic",
        genus: "organic",
        species: "organic"
      })), I(), window.setInterval(I, 432e5), function () {
        function e(e, n, t) {
          var r = t,
              o = e.match(n);
          return o && o.length > 1 && (r = o[1]), r;
        }

        var n = navigator.userAgent,
            t = "unknown",
            r = "unknown";
        -1 !== n.indexOf("Win") ? (t = "windows", r = e(n, /Windows NT ([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("iPhone OS") ? (t = "ios", r = (r = e(n, /iPhone OS ([^ ;)]*)/, "unknown")).replace(/_/g, ".")) : -1 !== n.indexOf("iPad") ? (t = "ios", r = (r = e(n, /CPU OS ([^ ;)]*)/, "unknown")).replace(/_/g, ".")) : -1 !== n.indexOf("Mac OS X") ? (t = "mac", r = (r = (r = e(n, /Mac OS X ([^ ;)]*)/, "unknown")).replace(/_/g, ".")).replace(/\.0$/, "")) : -1 !== n.indexOf("Android") ? (t = "android", r = (r = e(n, /Android ([^ ;)]*)/, "unknown")).replace(/_/g, ".")) : -1 !== n.indexOf("X11") ? t = "unix" : -1 !== n.indexOf("Linux") && (t = "linux");
        var o = "unknown",
            i = "unknown";
        -1 !== n.indexOf("Edge") ? (o = "edge", i = e(n, /Edge\/([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("Chrome") ? (o = "chrome", i = e(n, /Chrome\/([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("CriOS") ? (o = "chrome", i = e(n, /CriOS\/([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("Firefox") ? (o = "firefox", i = e(n, /Firefox\/([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("Android") ? (o = "android", i = e(n, /Version\/([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("Safari") ? (o = "safari", i = e(n, /Version\/([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("Trident") ? (o = "ie", i = e(n, /rv:([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("MSIE") ? (o = "ie", i = e(n, /MSIE ([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("MessengerForiOS") ? (o = "fbmessenger", i = e(n, /FBAV\/([^ ;)]*)/, "unknown")) : -1 !== n.indexOf("FB_IAB/MESSENGER") && (o = "fbmessenger", i = e(n, /FBAV\/([^ ;)]*)/, "unknown"));
        var a = "desktop";
        -1 !== n.indexOf("iPod") ? a = "ipod" : -1 !== n.indexOf("iPhone") ? a = "iphone" : -1 !== n.indexOf("iPad") ? a = "ipad" : -1 !== n.indexOf("Android") ? a = -1 === n.indexOf("Mobile") ? "android_tablet" : "android" : -1 !== n.indexOf("Mobile") && (a = "mobile"), k.os = t, k.os_ver = r, k.browser = o, k.browser_ver = i, k.device_type = a, k.device_family = a;
      }(), f = !0, T(), e.add_error_handler && window.addEventListener("error", j), n && n();
      var t;
    },
    isReady: function isReady() {
      return f;
    },
    getDeviceTag: function getDeviceTag() {
      return b;
    },
    addUserTag: function addUserTag(e) {
      var n;
      (m = e && String(e)) ? F("dc.user_tag", m) : (n = "dc.user_tag", delete window.localStorage[n]);
    },
    event: function event(n) {
      if (!n || "object" !== (void 0 === n ? "undefined" : e(n))) throw new Error("props must be an object");
      return n.type = "event", M(n);
    },
    economyEvent: function economyEvent(n) {
      if (!n || "object" !== (void 0 === n ? "undefined" : e(n))) throw new Error("props must be an object");
      if (!n.spend_currency) throw new Error("spend_currency is required");
      if ("number" != typeof n.spend_amount) throw new Error("spend_amount is required");
      return n.type = "economy", M(n);
    },
    messageSendEvent: function messageSendEvent(n) {
      if (!n || "object" !== (void 0 === n ? "undefined" : e(n))) throw new Error("props must be an object");
      if (!n.from_tag) throw new Error("from_tag is required");
      if (!n.to_tag && !n.to_list) throw new Error("to_tag or to_list is required");
      if (n.to_list && !Array.isArray(n.to_list)) throw new Error("to_list must be an array.");
      if (n.to_list || (n.to_list = []), n.to_tag && n.to_list.push(n.to_tag), 0 === n.to_list.length) throw new Error("must have at least 1 in to_list or a to_tag");
      return n.type = "message_send", M(n);
    },
    log: B,
    logEvent: V
  };
  return window.DataCortex = G, G;
});